import { render, staticRenderFns } from "./repairSetPage.vue?vue&type=template&id=e532ef36&scoped=true&"
import script from "./repairSetPage.vue?vue&type=script&lang=js&"
export * from "./repairSetPage.vue?vue&type=script&lang=js&"
import style0 from "./repairSetPage.vue?vue&type=style&index=0&id=e532ef36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e532ef36",
  null
  
)

export default component.exports